var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8002 5.99995C10.8002 8.65092 8.65116 10.8 6.0002 10.8C3.34923 10.8 1.2002 8.65092 1.2002 5.99995C1.2002 3.34898 3.34923 1.19995 6.0002 1.19995C8.65116 1.19995 10.8002 3.34898 10.8002 5.99995ZM6.60019 3.59995C6.60019 3.93132 6.33157 4.19995 6.0002 4.19995C5.66882 4.19995 5.4002 3.93132 5.4002 3.59995C5.4002 3.26858 5.66882 2.99995 6.0002 2.99995C6.33157 2.99995 6.60019 3.26858 6.60019 3.59995ZM5.4002 5.39995C5.06882 5.39995 4.8002 5.66858 4.8002 5.99995C4.8002 6.33132 5.06882 6.59995 5.4002 6.59995V8.39995C5.4002 8.73132 5.66882 8.99995 6.0002 8.99995H6.60019C6.93157 8.99995 7.20019 8.73132 7.20019 8.39995C7.20019 8.06858 6.93157 7.79995 6.60019 7.79995V5.99995C6.60019 5.66858 6.33157 5.39995 6.0002 5.39995H5.4002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.b44116db0696f9b56dd4377d9826dfe5.svg";
export { ForwardRef as ReactComponent };